import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Settings SVG Icon for settings call control button.
 */
export const Settings: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 36 35"
    aria-hidden={true}
    {...props}
  >
    <circle
      cx="17.9997"
      cy="28.786"
      r="3.08804"
      transform="rotate(-90 17.9997 28.786)"
      fill={props.fill ?? 'currentColor'}
    />
    <circle
      cx="17.9997"
      cy="17.6688"
      r="3.08804"
      transform="rotate(-90 17.9997 17.6688)"
      fill={props.fill ?? 'currentColor'}
    />
    <circle
      cx="17.9997"
      cy="6.5521"
      r="3.08804"
      transform="rotate(-90 17.9997 6.5521)"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
